
export const environment = {
  production: false,
  apiUrl: 'undefined',
  FACEINPHOTO_HOST: 'vvaldesc.ddns.net',
  FACEINPHOTO_PORT: '6000',
  FACEINPHOTO_PROXY: 'fbb0ece0-ed1f-11ef-8084-d37e473ef87d',
  OPENIA_API_KEY: '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',
  RAPIDAPI_KEY: '537517a32emsh5c0948f57af5a91p182ba2jsn0448a4034897'
};